import * as ACTION_TYPES from './types';

const normalizeResponeSearch = list => list.map(({
  patient, forPatient, conversationId, lastTimePatient, ...consult
}) => ({
  patient,
  forPatient,
  latestConsult: consult,
  id: conversationId,
  participant: {
    latestTime: lastTimePatient,
  },
}));

const initialState = {
  status: {
    loadingPatient: -1,
    loadMorePatient: -1,
    loadDoctor: -1,
  },
  patients: [],
  doctors: [],
  meta: {},
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.PATIENT_SEARCH_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadingPatient: 0,
        },
      };
    case ACTION_TYPES.PATIENT_SEARCH_SUCCEED: {
      const { meta } = action;
      const list = normalizeResponeSearch(payload.data);
      return {
        ...state,
        patients: meta?.isMore ? [...state.patients, ...list] : list,
        metaPatient: list.length > 0 ? payload.meta : null,
        status: {
          ...state.status,
          loadingPatient: 1,
        },
      };
    }
    case ACTION_TYPES.PATIENT_SEARCH_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadingPatient: 2,
        },
        error,
      };
    case ACTION_TYPES.PATIENT_CLEAR_SEARCH:
      return {
        ...state,
        patients: [],
        consultActiveSearch: undefined,
      };
    case ACTION_TYPES.PATIENT_GOTO_SEARCH:
      return {
        ...state,
        consultActiveSearch: payload,
      };
    case ACTION_TYPES.SEARCH_DOCTORS_INVITATION_SUCCEED: {
      const { meta } = action;
      return {
        ...state,
        status: { ...state.status, loadDoctor: 1 },
        doctors: meta.isLoadMore ? [...state.doctors, ...payload.data] : payload.data,
        meta: payload.meta,
      };
    }
    case ACTION_TYPES.SEARCH_DOCTORS_INVITATION_REQUESTED:
      return {
        ...state,
        status: { ...state.status, loadDoctor: 0 },
      };
    default:
      return state;
  }
}
